import { MessageCircle, Mail } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { EMAIL, WHATSAPP_URL } from "@/constants";

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="py-32 md:py-48 bg-olive text-cream relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="uppercase text-xs sm:text-sm tracking-[0.28em] font-medium text-sage" data-testid="contact-overline">
          Say Hello
        </p>
        <h2 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95] mt-6 max-w-3xl" data-testid="contact-heading">
          Begin your <span className="italic text-sage">practice</span>
        </h2>
        <p className="mt-8 max-w-md text-base sm:text-lg leading-relaxed font-light tracking-wide text-cream/70" data-testid="contact-subtext">
          A message is all it takes. Tell me a little about yourself and what
          you're looking for, and we'll arrange your first session at home.
        </p>
      </Reveal>

      <Reveal delay={0.2}>
        <div className="mt-14 flex flex-col sm:flex-row gap-4 sm:gap-6">
          <a
            data-testid="whatsapp-cta-button"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center gap-3 rounded-full bg-cream text-olive px-9 py-4 text-sm tracking-[0.14em] uppercase transition-all duration-400 hover:bg-sage hover:text-cream hover:-translate-y-0.5"
          >
            <MessageCircle className="w-4 h-4" />
            WhatsApp me
          </a>
          <a
            data-testid="email-cta-button"
            href={`mailto:${EMAIL}`}
            className="group inline-flex items-center justify-center gap-3 rounded-full border border-cream/40 text-cream px-9 py-4 text-sm tracking-[0.14em] uppercase transition-all duration-400 hover:border-cream hover:bg-cream/10 hover:-translate-y-0.5"
          >
            <Mail className="w-4 h-4" />
            Email me
          </a>
        </div>
        <p className="mt-10 text-sm font-light tracking-wide text-cream/50" data-testid="contact-details">
          {EMAIL} · WhatsApp +41 79 672 98 90 · Bath, UK
        </p>
      </Reveal>
    </div>
  </section>
);
